import { getExtenstionByUrl } from "@/utils/file";
import { v4 as uuidv4 } from "uuid";
import { reactive } from "vue";
import { encrypt } from "@/utils/crypt";
import { getQiNiuUploadFileUrl } from "@/utils/qiniu";
import { getDetectImage } from "@/api/chatApi";
import { ElMessage } from "element-plus";

const oriStatus = {
  type: "input", // input 是 输入框模式，command 是 自定义输入模式
  // 当前选中的指令的信息
  curCommand: {},
  // 当前选中的模板，没有的时候为空
  curTemplate: null,
  content: "",
  // 用户当前选择的文件
  curFile: {
    // 作为判断是否有上传文件
    id: null,
    // 使用的哪个指令 id
    curCommandId: null,
    status: "empty", // uploading, success, error, empty, convert, convert 时，触发弹窗提示
    name: "",
    url: "",
    size: 0,
    progress: 0,
    error: "",
    file: null,
    // 文件后缀
    ext: "",
    isScan: false, //是否扫描件，PDF时用到
    originalName: "", //某些情况，name会做出改动，这个值与name第一次赋值时相同
    serialID: "", //任务序列号
  },
  // 引用列表
  quotationList: [
    // {
    //   url: "https://blog.csdn.net/Heartbroken_man/article/details/131199571",
    //   id: "037c0d44-bcdd-4d42-a2a8-4ea952b3f7dd",
    //   status: "success",
    //   ext: "",
    //   name: "https://blog.csdn.net/Heartbroken_man/article/details/131199571",
    //   curCommandId: "WYZY",
    // },
    // {
    //   id: 1724637472836,
    //   curCommandId: "YDZJ",
    //   status: "success",
    //   name: "维多利亚维多利亚维多利亚维多利亚维多利亚维多利亚维多利亚维多利亚维多利亚维多利亚.pdf",
    //   url: "https://123botcdn.pcdashi.cn/chat/2024-08-26/731ba7f2-c36f-436d-8d06-96d4a59d2539-----2FMcgjRfaf3jIDR--2BJy--2FQ--2F1hJRI1lQfxqoCrbRFTrz4CM--3D.pdf",
    //   size: 103981,
    //   progress: 0,
    //   error: "",
    //   file: {
    //     cloudPath: "1724637472835_0.pdf",
    //     uuid: 1724637472836,
    //   },
    //   ext: "pdf",
    // },
    // {
    //   id: 1724637472836,
    //   curCommandId: undefined,
    //   status: "success",
    //   name: "维多利亚维多利亚维多利亚维多利亚维多利亚维多利亚维多利亚维多利亚维多利亚维多利亚.pdf",
    //   url: "https://123botcdn.pcdashi.cn/chat/2024-08-26/731ba7f2-c36f-436d-8d06-96d4a59d2539-----2FMcgjRfaf3jIDR--2BJy--2FQ--2F1hJRI1lQfxqoCrbRFTrz4CM--3D.pdf",
    //   size: 103981,
    //   progress: 0,
    //   error: "",
    //   file: {
    //     cloudPath: "1724637472835_0.pdf",
    //     uuid: 1724637472836,
    //   },
    //   ext: "pdf",
    // },
  ],
};
const status = reactive(oriStatus);

const ALLOWED_IMAGE_EXT = ["jpg", "png", "jpeg"];
const ALLOWED_DOCUMENT_EXT = ["pdf", "doc", "docx"];

async function uploadToQiniu(file, options, fileType) {
  try {
    const fileDownloadName = encodeURIComponent(
      encrypt(options.fileName || `${new Date().getTime()}`)
    ).replace(/%/g, "--");
    const uploadQiNiuUrl = await getQiNiuUploadFileUrl(
      file,
      "chat/",
      fileDownloadName
    );
    // console.log("fileType", fileType);
    if (fileType === "image") {
      try {
        await getDetectImage(uploadQiNiuUrl);
      } catch (error) {
        console.log("getDetectImage", error);
        throw new Error("检测到违规图片，请重新上传");
      }
    }
    return uploadQiNiuUrl;
  } catch (e: any) {
    ElMessage({
      message: e?.message || "上传失败",
      type: "error",
      duration: 1000,
    });
    throw new Error("upload error");
  }
}

export async function uploadCurFile(fileInfo) {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    if (!fileInfo) return;
    const { name, size, uuid, file, extname } = fileInfo;
    const newFile = {
      id: uuid || uuidv4(),
      curCommandId: undefined,
      status: "uploading", // uploading, success, error, empty
      name,
      url: "",
      size,
      progress: 0,
      error: "",
      file,
      // 文件后缀
      ext: extname || getExtenstionByUrl(name),
      originalName: name,
      serialID: "",
    };
    Object.assign(status.curFile, newFile);
    try {
      let fileType = "file";
      if (ALLOWED_IMAGE_EXT.includes(newFile.ext)) {
        fileType = "image";
      }

      status.curFile.status = "uploading";
      const key = await uploadToQiniu(
        newFile.file,
        {
          fileName: newFile.name,
        },
        fileType
      );
      status.curFile.url = key;
      status.curFile.status = "success";
      resolve(key);
    } catch (error) {
      console.log("上传失败", error);
      status.curFile.status = "error";
      reject(error);
    }
  });
}

export const inputForm = reactive({
  r1: false,
  network: false,
  inputValue: "",
});

export const resetInputBar = () => {
  inputForm.r1 = false;
  inputForm.network = false;
  inputForm.inputValue = "";
};
